export function isLowStock(quantity: number, threshold: number): boolean {
  return Number.isFinite(quantity) && Number.isFinite(threshold) && threshold >= 0 && quantity <= threshold;
}
